import React from 'react';
import { House, People, Truck, TruckFront } from 'react-bootstrap-icons';
import AdminDashboardPage from '../../app/dashboard';
import AdminTrailerPage from '../../app/trailer';
import AdminTruckPage from '../../app/truck';
import AdminTruckBrandPage from '../../app/truck-brand';
import AdminUserPage from '../../app/user';

export const routes = [
  {
    name: 'general.dashboard',
    icon: <House />,
    route: '/admin/dashboard',
    component: <AdminDashboardPage />,
  },
  {
    name: 'general.truck',
    icon: <Truck />,
    route: '/admin/truck',
    component: <AdminTruckPage />,
  },
  {
    name: 'general.truckBrand',
    icon: <TruckFront />,
    route: '/admin/truck-brand',
    component: <AdminTruckBrandPage />,
  },
  {
    name: 'general.trailer',
    icon: <Truck />,
    route: '/admin/trailer',
    component: <AdminTrailerPage />,
  },
  {
    name: 'general.user',
    icon: <People />,
    route: '/admin/user',
    component: <AdminUserPage />,
  },
];
